module.exports = __webpack_public_path__ + "static/media/scdream8.3b65d28c.woff2";